import {ReactNode} from 'react'

export const ServiceRequestFooter = ({children}: { children: ReactNode }) => {
    return <div className="service-request-form-footer">
        {children}
    </div>
}